import {connect} from 'react-redux';
import {pick} from 'lodash';
import CollegeApplicationStatusModal from '../components/college-application-status-modal';
import {getCollegeAppStatuses, setCollegeAppStatus} from '../actions/college-application-status';
import {getFollowedColleges} from '../actions/college-application-status-modal';

const mapStateToProps = (state) => ({
  ...pick(state, ['followedColleges', 'collegeApplicationStatuses']),
});

const mapDispatchToProps = (dispatch) => ({
  getFollowedColleges: () => {
    dispatch(getFollowedColleges());
  },
  setCollegeAppStatus: (collegeId, status, segmentEventLocation) => {
    dispatch(setCollegeAppStatus(collegeId, status, segmentEventLocation));
  },
  getCollegeAppStatuses: (collegeId) => {
    dispatch(getCollegeAppStatuses(collegeId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CollegeApplicationStatusModal);
